import { InvoicesBoundary } from "./boundary"
import { AllInvoices, IAllInvoices } from "./views/AllInvoices"

export const VAllInvoices: React.FC<IAllInvoices> = (props) => (
  <InvoicesBoundary>
    <AllInvoices {...props} />
  </InvoicesBoundary>
)
